module.exports = __webpack_public_path__ + "img/白前.e545a87e.jpg";